import axios from 'axios';

const baseUrl = process.env.REACT_APP_URL_SERVER;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const Consumptions = {

  /**
   * A partir de las siguientes funciones obtenemos los datos de la calculadora.
   */
  getRates: (type) => {
    const response = axios({
      url: `${baseUrl}/api/cfe/rates/${type}?code=${apiCode}`,
      method: 'GET',
    })
      .then((res) => {
        const abc = ['', 'A', 'B', 'C', 'D', 'E', 'F'];
        res.data.tarifas.sort((a, b) => abc.indexOf(a.id_tarifa.split(1)[1]) - abc.indexOf(b.id_tarifa.split(1)[1]));
        return res.data;
      })
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  getChargesByRegion: (tarifa) => {
    const response = axios({
      url: `${baseUrl}/api/cfe/regions/${tarifa}/charges?code=${apiCode}`,
      method: 'GET',
    })
      .then((res) => {
        const abc = ['ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
          'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE ', 'DICIEMBRE'];
        res.data.cargos.sort((a, b) => abc.indexOf(a.id_cargo.split('- ')[1]) - abc.indexOf(b.id_cargo.split('- ')[1]));
        return res.data;
      })
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },

  getConsumptionsByProduct: (id) => {
    const response = axios({
      url: `${baseUrl}/api/products/consumptions?code=${apiCode}`,
      method: 'POST',
      data: JSON.stringify({ product: id }),
      contentType: 'application/json',
    })
      .then((res) => {
        const sortedResponse = (res.data?.consumos?.length > 0
        && res.data?.consumos.sort((a, b) => a.porcentaje_trabajo - b.porcentaje_trabajo));
        return sortedResponse;
      })
      .catch((err) => {
        const error = err.response?.data.message || err.toString();
        return { error: { message: error.responseJSON?.message } };
      });
    return response;
  },
};

export default Consumptions;
